<div class="cancel-box">
  <div class="modal-header d-flex justify-content-between" appDraggable>
    <i></i>

    <div class="d-flex align-items-center p-0"><h4 class="modal-title">{{'labelCancelOrder' | translate}}
      <span>{{trade.sixLetterCode | getFirstCC}}</span></h4></div>

    <div>
      <button class="close btn" (click)="close()">
        <i class="fa fa-times fa-2x"></i>
      </button>
    </div>

  </div>
  <div class="modal-body mr-5 ml-5">

    <div class="row">

      <div class="col-2 d-flex align-items-center">
        <button type="button" class="btn btn-secondary" tabindex="-1" disabled>{{trade.direction | translate}}</button>
      </div>

      <div
        class="col-2 d-flex align-items-center font-weight-bold text-center text-nowrap h4">{{baseOrder.isInverted ? (trade.sixLetterCode | getFirstCC) : (trade.sixLetterCode | getSecondCC)}} {{'labelVs' | translate}}</div>

      <div class="col-6 align-self-center">
        <angular2-multiselect [data]="dropdownList"
                              [(ngModel)]="selectedItems"
                              tabindex="-1"
                              [settings]="dropdownSettings">
        </angular2-multiselect>

      </div>

      <div class="col-2 d-flex align-items-center text-right">
        <label class="check-disabled">
          <input
            tabindex="-1"
            type="checkbox"
            id="col.name"
            class="custom-control-input"
            [checked]="!!baseOrder.ocoLinkId"
            disabled
          />

          <span class="checkmark"></span>

          <b>OCO</b>
        </label>
      </div>


    </div>

    <!--  table block -------------------- -->
    <div class="cancelTable">

      <div class="row modalTableHeader pb-4">
        <div class="col-3">Qty</div>
        <div class="col-3">{{'labelAmnt' | translate}}</div>
        <div class="col-2">&#64;</div>
        <div class="col-2">Factor</div>
        <div class="col-2">eq. %</div>
      </div>

      <div class="modalTableScroll">

        <!-- FIRST ROW -------------------------------------------------- -->
        <div class="row first-line">
          <!-- Qty-------------------------------------------------- -->
          <div class="flex-nowrap col-3">
            <div class="input-group input-group-sm flex-nowrap">
              <input [textMask]="{mask: qmask}" disabled [(ngModel)]="baseOrder.quantity" id="quantity"
                     class="form-control form-control-sm">
              <div class="input-group-append">
                <span class="input-group-text">{{baseOrder.sixLetterCode | getFirstCC}}</span>
              </div>
            </div>
          </div>

          <!-- Amnt-------------------------------------------------- -->
          <div class="flex-nowrap col-3">
            <div class="input-group input-group-sm flex-nowrap">
              <input class="form-control form-control-sm" [textMask]="{mask: amask}" [(ngModel)]="amount" disabled>
              <div class="input-group-append">
                <span class="input-group-text">{{baseOrder.sixLetterCode | getSecondCC}}</span>
              </div>
            </div>
          </div>


          <!-- @ -------------------------------------------------- -->
          <div class="flex-nowrap col-2">
            <div class="input-group input-group-sm flex-nowrap">
              <input
                disabled
                [(ngModel)]="baseOrder.profit"
                [textMask]="{mask: mask}"
                class="form-control"
                autocomplete="off"/>
            </div>
          </div>

          <!-- Factor -------------------------------------------------- -->
          <div class="col mt-2 factor">
            x{{swapPriceFactor}}
          </div>

          <!-- eq -------------------------------------------------- -->
          <div class="flex-nowrap col-2">
            <div class="input-group input-group-sm col flex-nowrap">
              <input [(ngModel)]="swapRate" disabled class="form-control">
            </div>
          </div>

        </div>
        <div *ngIf="isOcoActive">
          <div class="row ocoact" *ngFor="let oco of ocos">
            <!--                 (click)="setOcoToRangeSlider(oco)"-->

            <!-- Qty-------------------------------------------------- -->
            <div class="flex-nowrap col-3">
              <div class="input-group input-group-sm flex-nowrap">
                <input [textMask]="{mask: qmask}" [(ngModel)]="oco.quantity" disabled class="form-control form-control-sm">
                <div class="input-group-append">
                  <span class="input-group-text">{{oco.sixLetterCode | getFirstCC}}</span>
                </div>
              </div>
            </div>

            <!-- Amnt-------------------------------------------------- -->
            <div class="flex-nowrap col-3">
              <div class="input-group input-group-sm flex-nowrap">
                <input class="form-control form-control-sm" [textMask]="{mask: amask}" [(ngModel)]="amount" disabled>
                <div class="input-group-append">
                  <span class="input-group-text">{{oco.sixLetterCode | getSecondCC}}</span>
                </div>
              </div>
            </div>

            <!-- @ -------------------------------------------------- -->
            <div class="col-2 flex-nowrap">
              <div class="input-group input-group-sm flex-nowrap">
                <input
                  disabled
                  [(ngModel)]="oco.swapPrice"
                  [textMask]="{mask: mask}"
                  class="form-control"
                  autocomplete="off"/>
              </div>
            </div>

            <!-- Factor -------------------------------------------------- -->
            <div class="col-2 mt-2 factor">
              x{{getCpFactor(oco.sixLetterCode)}}
            </div>

            <!-- eq -------------------------------------------------- -->
            <div class="col-2 flex-nowrap">
              <div class="input-group input-group-sm">
                <input disabled [(ngModel)]="oco.swapRate" class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" tabindex="-1" class="btn btn-danger" (click)="cancelOrder()"><i
      class="fa fa-times"></i> {{'buttonCancelOrder' | translate}}</button>
  </div>
</div>
